import axios from 'axios';

export default {
  getModules: () => axios.get('/modules'),
  getAppSettings: () => axios.get('/settings'),
};
